<template>
  <div class="page home-page">
    <HomeHero :image="IMAGES.hero" />
    <HomeWhoWeAre />
    <HomePainPoints />
    <HomeEcosystems />
    <HomePersonas />
    <HomeValueProposition />
    <HomeJoin />
    <HomeCTA :image="IMAGES.partner" />
  </div>
</template>

<script>
import { IMAGES } from '@/constants/ecosystemData';
import HomeHero from '@/components/sections/HomeHero.vue';
import HomeWhoWeAre from '@/components/sections/HomeWhoWeAre.vue';
import HomePainPoints from '@/components/sections/HomePainPoints.vue';
import HomeEcosystems from '@/components/sections/HomeEcosystems.vue';
import HomePersonas from '@/components/sections/HomePersonas.vue';
import HomeValueProposition from '@/components/sections/HomeValueProposition.vue';
import HomeJoin from '@/components/sections/HomeJoin.vue';
import HomeCTA from '@/components/sections/HomeCTA.vue';

export default {
  name: 'HomePage',
  components: {
    HomeHero,
    HomeWhoWeAre,
    HomePainPoints,
    HomeEcosystems,
    HomePersonas,
    HomeValueProposition,
    HomeJoin,
    HomeCTA
  },
  data() {
    return { IMAGES };
  },
  mounted() {
    this.observeReveals();
  },
  methods: {
    observeReveals() {
      this.$nextTick(() => {
        const els = document.querySelectorAll('.reveal:not(.show)');
        if (!('IntersectionObserver' in window)) {
          els.forEach(x => x.classList.add('show'));
          return;
        }
        const ob = new IntersectionObserver(
          (entries) => {
            entries.forEach(e => {
              if (e.isIntersecting) {
                e.target.classList.add('show');
                ob.unobserve(e.target);
              }
            });
          },
          { threshold: 0.08 }
        );
        els.forEach(x => ob.observe(x));
      });
    }
  }
};
</script>

<style>
.home-page > section {
  position: relative;
  z-index: 1;
}
</style>
